import React, { useCallback, useEffect, useState } from "react";
import styles from "./Login.module.css";
import { useNavigate } from "react-router-dom";
import { Header } from "../NavBar/Header";
import { Row, Card, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
// import SignInInput from '../../Common/SigninInput/signinInput'
import LoginInput from "../../component/signup/loginInput";
import EmailVerification from "../../component/signup/emailVerification";
import CreateAccount from "../../component/signup/createAccount";
import axios from "axios";
import { userLoginApi, Signup, SendOtp, VerifyOtp, ResendOtp, createPlan } from "../../api";
import NewHeader from "../NavBar/newHeader";
import OnboardingFooter from "../../component/Footer/OnboardingFooter";
import { useMyContext } from "../../myContext";

const Login = ({ onLogin }) => {
  const [stepToShow, setStepToShow] = useState("login");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userExist, setUserExist] = useState(false);
  const [curretAccountButtonDisabled, setCurrentAccountButtonDiabled] =
    useState(true);
  const [emailError, setEmailError] = useState("");
  const [userNameInvalid, setUsernameInvalid] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [passwordInvalid, setPasswordInvalid] = useState(false);
  const [confirmPasswordInvalid, setConfirmPasswordInvalid] = useState(false);
  const [incorrectpasswordoremail, setIncorrectPasswordorEmail] = useState("");
  const [otperror, setOtpError] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState("");
  const [loading, setLoading] = useState(false);
  const { username, setUsername, hashId, setHashId, planId, partnerCode, setIsForgotRoute } = useMyContext();
  const navigate = useNavigate();


  useEffect(() => {
    setIsForgotRoute(false)
  },[])

  const userLogin = () => {
    setShowError("");
    setLoading(true);
    try {
      const data = {
        username: username,
        password: password,
        partnerCode: partnerCode
      };
      userLoginApi(data).then((resp) => {
        setLoading(false);
        if (resp && resp.status === 200 && resp.data && resp.data.access_token !== "") {
          const token = {
            accessToken: resp.data.access_token,
            refreshToken: resp.data.refresh_token,
          };
          sessionStorage.setItem("token", JSON.stringify(token));
          onLogin(true);
          navigate('/transaction-detail');
          // window.location.reload();
        } else if (resp && resp.data && resp.data.status === 401) {
          setPasswordInvalid(true);
          setUsernameInvalid(true);
          setIncorrectPasswordorEmail(resp.data.message);
        } else {
          setShowError(resp && resp.data ? resp.data.message : "something went wrong, please try again later.");
        }
      });
    } catch (error) {
      setLoading(false);
      setShowError("something went wrong, please try again later.");
    }
  };

  const checkUsernamViaOtp = () => {
    if (ValidateEmail()) {
    setLoading(true);
    const bodydata = {
      reason: "create_account",
      username,
      partnerCode: partnerCode
    };
    try{
    SendOtp(bodydata).then((resp) => {
      setShowError("");
      setLoading(false);
      if (resp && resp.status === 200) {
        if (resp.message === "user already exist") {
          setUserExist(true);
        } else {
          setUserExist(false);
          const hashid = resp.data.hashId;
          setHashId(hashid);
          setShowError("");
          setStepToShow("emailOtp");
        }
      } else {
        if(resp?.status === 400){
          setShowError(resp?.data?.message);
        } else{
          setShowError(resp ? resp?.message : "something went wrong, please try again later.");
        }
        setLoading(false);
      }
    });
  }
  catch(err){
  }
  }
  };

  const createNewAccount = async () => {
    setShowError("");
    setLoading(true);
    try {
      const body = {
        username: username,
        password: password,
        hashId: hashId,
        partnerCode: partnerCode
      };
      Signup(body).then((resp) => {
        setLoading(false);
        if (resp && resp.status === 200) {
          const token = {
            accessToken: resp.data.tokenData.access_token,
            refreshToken: resp.data.tokenData.refresh_token,
          };
          sessionStorage.setItem("token", JSON.stringify(token));
          onLogin(true);
          navigate('/transaction-detail');
          // window.location.reload();
        } else {
          setShowError(resp ? resp.message : "something went wrong, please try again later.");
        }
      });
    } catch (error) {
      setShowError("something went wrong, please try again later.");
      setLoading(false);
    }
  };

  // api deprecated from the flow
  
  // const assignPlan = async() => {
  //   try{
  //     const body = {
  //       "planId":planId,
  //     }
  //     createPlan(body).then((resp) => {
  //       if(resp && resp.status === 200){
  //         setLoading(false);
  //       }
  //     })
  //   }catch(err){
  //     setShowError("something went wrong, please try again later.");
  //     setLoading(false);
  //   }
  // }

  const passwordValidation = () => {
    setConfirmPasswordError("");
    let errorMessage = "";
    const testLength = /^(?=.{8,})/.test(password);
    const testAplha = /^(?=.*[a-z])/.test(password);
    const testUpperCase = /^(?=.*[A-Z])/.test(password);
    const testNumber = /^(?=.*[0-9])/.test(password);
    const testSpecialChar = /^(?=.*[!@#$%^&*])/.test(password);
    if (!testLength) {
      errorMessage = "Password must have 8 or more characters";
    } else if (!testAplha) {
      errorMessage = "Password needs to include atleast one lowercase alphabet";
    } else if (!testUpperCase) {
      errorMessage = "Password needs to include atleast one Uppercase alphabet";
    } else if (!testNumber) {
      errorMessage = "Password needs to include atleast number";
    } else if (!testSpecialChar) {
      errorMessage = "Password needs to include atleast one special symbol";
    } else {
      errorMessage = "";
      setPasswordInvalid("");
    }
    if (errorMessage !== "") {
      setPasswordInvalid(true);
    } else if (password !== confirmPassword) {
      errorMessage = "Password should be same as above";
      setConfirmPasswordInvalid(true);
    }
    if (password === confirmPassword) {
      setConfirmPasswordInvalid(false);
    }
    setConfirmPasswordError(errorMessage);
    return errorMessage;
  };

  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(username)) {
      setEmailError("");
      setUsernameInvalid(false);
      return true;
    } else {
      setEmailError("Enter a valid email such as example@email.com");
      setUsernameInvalid(true);
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "email") {
      setUsername(e.target.value.toLowerCase());
    } else if (e.target.name === "password") {
      setPassword(e.target.value);
    } else if (e.target.name === "confirm_password") {
      setConfirmPassword(e.target.value);
    }
    setPasswordInvalid(false);
    setUsernameInvalid(false);
    setIncorrectPasswordorEmail("");
  };
  useEffect(() => {
    if (otp !== "") {
      checkOtp();
    }
  }, [otp]);

  const checkOtp = useCallback(() => {
    if (otp.length === 6) {
      otpVerification();
    }
  }, [otp]);

  const otpVerification = async () => {
    setErrorMessage("");
    setLoading(true);
    const body = {
      otp: otp,
      hashId: hashId,
    };
    try {
      VerifyOtp(body).then((resp) => {
        setLoading(false);
        if (resp && resp.status === 200) {
          setStepToShow("createAccount");
        } else {
          setOtpError(resp && resp.data ? resp.data.message : "something went wrong, please try again later.");
          if(resp?.data?.message === "Number of attempts exceeded: Please try again after 3 mins"){
            setTimeout(() => {
              setStepToShow("login");
              setOtpError("");
            }, [3000])
          }
        }
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const resendOtpVerification = async () => {
    setOtpError("");
    setOtp("");
    setLoading(true);
    const body = {
      reason: "resend_otp",
      hashId: hashId,
      username: username,
      partnerCode: partnerCode
    };
    try {
      ResendOtp(body).then((resp) => {
        setLoading(false);
        const hashid = resp.data && resp.data.data ? resp.data.data.hashId : "";
        setHashId(hashid);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  const ForgotPasswordOtp = () => {
    setLoading(true);
    const bodydata = {
      reason: "forgot_password",
      username,
      partnerCode: partnerCode
    };
    SendOtp(bodydata).then((resp) => {
      setLoading(false);
      if (resp.status === 200) {
        setUserExist(false);
        const hashid = resp.data.hashId;
        setHashId(hashid);
        setErrorMessage("");
      } else {
        setErrorMessage(resp ? resp.message : "something went wrong, please try again later.");
        setLoading(false);
      }
    });
  };

  const showComponent = () => {
    switch (stepToShow) {
      case "login":
        return (
          <LoginInput
            setUsername={setUsername}
            username={username}
            handleChange={handleChange}
            setStepToShow={setStepToShow}
            password={password}
            setPassword={setPassword}
            userExist={userExist}
            emailError={emailError}
            userNameInvalid={userNameInvalid}
            userLogin={userLogin}
            passwordInvalid={passwordInvalid}
            incorrectpasswordoremail={incorrectpasswordoremail}
            loading={loading}
            showError={showError}
            checkUsernameViaOtp={checkUsernamViaOtp}
            setIncorrectPasswordorEmail={setIncorrectPasswordorEmail}
            setPasswordInvalid={setPasswordInvalid}
            ForgotPasswordOtp={ForgotPasswordOtp}
            setUserExist={setUserExist}
          />
        );
      case "emailOtp":
        return (
          <EmailVerification
            username={username}
            setStepToShow={setStepToShow}
            loading={loading}
            otpVerification={otpVerification}
            setOtp={setOtp}
            otp={otp}
            otperror={otperror}
            resendOtpVerification={resendOtpVerification}
            errorMessage={errorMessage}
            Title={"Verify your email"}
            isEdit={true}
          />
        );
      case "createAccount":
        return (
          <CreateAccount
            username={username}
            setStepToShow={setStepToShow}
            loading={loading}
            navigate={navigate}
            handleChange={handleChange}
            setConfirmPassword={setConfirmPassword}
            confirmPassword={confirmPassword}
            curretAccountButtonDisabled={curretAccountButtonDisabled}
            passwordValidation={passwordValidation}
            createNewAccount={createNewAccount}
            confirmPasswordError={confirmPasswordError}
            passwordInvalid={passwordInvalid}
            confirmPasswordInvalid={confirmPasswordInvalid}
            showError={showError}
            Title={"Create your Account"}
            Subtitle={"Enter your password to Login."}
            ButtonTitle={"Create Account"}
          />
        );
      default:
        return <LoginInput />;
    }
  };

  return (
    <>
      <NewHeader show={false} />
      <div className={styles.cardDiv}>
        <Card className={styles.cardSignUp}>
          <Card.Body className={styles.cardBodySignup}>
            {showComponent()}
          </Card.Body>
        </Card>
      </div>
      <OnboardingFooter />
    </>
  );
};

export default Login;
